import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { setModalsData, TModalsState } from "../../api/store/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { AdminFormFieldSubmit } from "../../components/admin/formFields";

type ModalRequestVideoProps = {
  onVideoRequestConfirm: (timestamp: number) => void;
  onVideoRequestCancel: () => void;
};

const ModalRequestVideo: FC<ModalRequestVideoProps> = ({
  onVideoRequestConfirm,
  onVideoRequestCancel,
}) => {
  const { t: tMain } = useTranslation();
  const { t } = useTranslation("translation", {
    keyPrefix:
      "camera.dashboard.management.cameras.camera_details.tabs.storage",
  });
  const modalsState: TModalsState = useSelector(
    (state: any) => state.commonReducer.modals
  );

  const dispatch = useDispatch();

  const hideModal = () => {
    dispatch(
      setModalsData({
        ...modalsState,
        showRequestVideo: { ...modalsState.showRequestVideo, show: false },
      })
    );
  };

  const handleCancel = () => {
    onVideoRequestCancel();
    hideModal();
  };

  const handleSubmit = () => {
    onVideoRequestConfirm(modalsState.showRequestVideo.timestamp);
    hideModal();
  };

  if (modalsState.showRequestVideo.show === false) return null;
  return (
    <>
      <div
        className="fixed w-full h-screen top-0 left-0 bg-modal-overlay z-overlay"
        onClick={hideModal}
      ></div>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none z-modal">
        <div className="relative my-6 mx-auto max-w-[calc(100vw-4rem)] w-[480px] z-modal">
          <form
            className="p-8 bg-white grid grid-cols-6 gap-6 rounded-3xl shadow-2xl"
            onSubmit={handleSubmit}
          >
            <h2 className="col-span-6 text-3xl font-bold text-heading-black">
              {"Request Video"}
            </h2>
            <p className="col-span-6 mt-0 leading-relaxed text-gray-500">
              {`Are you sure you want to request video?`}
            </p>
            <AdminFormFieldSubmit
              label={"Proceed"}
              type="button"
              variant="primary"
              onClick={handleSubmit}
            />

            <AdminFormFieldSubmit
              label={tMain("cancel")}
              type="button"
              variant="danger-transparent"
              onClick={handleCancel}
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default ModalRequestVideo;
